import { render, staticRenderFns } from "./StudentStories.vue?vue&type=template&id=0b59aded&scoped=true&"
import script from "./StudentStories.vue?vue&type=script&lang=js&"
export * from "./StudentStories.vue?vue&type=script&lang=js&"
import style0 from "./StudentStories.vue?vue&type=style&index=0&id=0b59aded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59aded",
  null
  
)

export default component.exports